module.exports = __webpack_public_path__ + "static/media/PinkColorLoader.ba810c15.gif";